import { FormInput } from 'src/@types';
import { getDefaultValue } from 'src/components/shared/form-elements';
import { CalculatorsHomeValueStep1FormFields } from '../../../../../@types/features/calculators';
import { IntlShape } from 'react-intl/src/types';

export const useCalculatorHomeValueStep1FormFields = (intl: IntlShape) => {
  const calculatorHomeValueStep1FormFields: Record<
    keyof CalculatorsHomeValueStep1FormFields,
    FormInput
  > = {
    postalCode: {
      fieldName: 'postalCode',
      label: intl.formatMessage({
        id: 'step1.postalCode',
        defaultMessage: 'Postcode'
      }),
      type: 'text',
      required: true,
      placeHolder: '1234AB',
      defaultValue: getDefaultValue('3037GD')
    },
    houseNumber: {
      fieldName: 'houseNumber',
      label: intl.formatMessage({
        id: 'step1.houseNumber',
        defaultMessage: 'Huisnummer'
      }),
      type: 'number',
      required: true,
      placeHolder: '12',
      defaultValue: getDefaultValue('153')
    },
    houseNumberExt: {
      fieldName: 'houseNumberExt',
      label: intl.formatMessage({
        id: 'step1.houseNumberExt',
        defaultMessage: 'Toevoeging'
      }),
      type: 'select',
      required: false,
      placeHolder: 'A',
      defaultValue: getDefaultValue('B')
    }
  };
  return calculatorHomeValueStep1FormFields;
};
